export default __webpack_public_path__ + "Src/Client/Subscriptions/unsubscribeSubscriptionsView.html";